import type { ImprovementAction } from '~/gql/quality/quality'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { Button } from '~/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table'
import { ACTION_STATUS_KEYS, ACTION_STATUS_VARIANTS, ORIGIN_KEYS } from './quality-labels'

type IProps = {
  actions: readonly ImprovementAction[]
  formatDate: (value: unknown) => string
  onOpen: (action: ImprovementAction) => void
}

/** Une ligne par action (#328) : son origine, son intitulé et qui la porte, son échéance, son état. */
function ImprovementActionsTable({ actions, formatDate, onOpen }: IProps) {
  const { t } = useTranslation()

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('quality.actions.column.origin')}</TableHead>
          <TableHead>{t('quality.column.title')}</TableHead>
          <TableHead>{t('quality.actions.column.dueDate')}</TableHead>
          <TableHead>{t('quality.column.status')}</TableHead>
          <TableHead><span className="sr-only">{t('quality.column.actions')}</span></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {actions.map(a => (
          <TableRow key={a.id}>
            <TableCell>{t(ORIGIN_KEYS[a.origin])}</TableCell>
            <TableCell>
              <div className="flex min-w-0 flex-col">
                <span className="font-medium">{a.title}</span>
                {a.owner && <span className="text-xs text-muted-foreground">{a.owner}</span>}
              </div>
            </TableCell>
            <TableCell className="whitespace-nowrap">{a.dueDate ? formatDate(a.dueDate) : '—'}</TableCell>
            <TableCell><Badge variant={ACTION_STATUS_VARIANTS[a.status]}>{t(ACTION_STATUS_KEYS[a.status])}</Badge></TableCell>
            <TableCell className="text-right">
              <Button variant="outline" size="sm" onClick={() => onOpen(a)} aria-label={t('common.actionFor', { action: t('quality.open'), name: a.title })}>
                {t('quality.open')}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default ImprovementActionsTable
